<app-modal
  [open]="open"
  (closed)="closeModal()"
>
  <ng-container modal-header>
    <h2>{{ 'share-profile-modal.title'|transloco }}</h2>
  </ng-container>
  <ng-container modal-body>
    <div class="input-group">
      <label for="url">{{ 'share-profile-modal.url.label'|transloco }}</label>
      <div class="input-group__input">
        <input type="url" [value]="url" id="url" readonly/>
        <button class="button button--secondary" (click)="copyUrl()">
          <i class="fa-solid fa-copy"></i>
        </button>
      </div>
    </div>

    @if (url) {
      <div class="qr-code" #qrHost>
        <qrcode
          [qrdata]="url"
          [width]="180"
          [margin]="1"
          [errorCorrectionLevel]="'M'"
          [allowEmptyString]="false"
          elementType="svg"
        ></qrcode>
      </div>

      <button class="button button--primary button--full-width qr-code__download-button"
              (click)="downloadQrAsPng(qrHost)">
        {{ 'share-profile-modal.download-qr'|transloco }}
        <i class="fa-solid fa-download"></i>
      </button>
    }
  </ng-container>
  <ng-container modal-footer>
    <div class="actions">
      <button class="button button--secondary" (click)="closeModal()">
        {{ 'share-profile-modal.cta'|transloco }}
      </button>
    </div>
  </ng-container>
</app-modal>
